import React, { useEffect, useState } from 'react'
import { View } from 'react-native'
import BuilderBottomModal from '../molecules/BuilderBottomModal'
import { useResponsive } from '../../utils/hooks'
import { useTranslation } from 'react-i18next'
import { ListItem } from '../atoms/builder-2.0/ListItem'
import { ArrowBlue, CardIconBuilder } from '../../assets/icons'
import { useStore } from '../../store'
import { AddNewButton } from '../add-payment-method-components/AddNewButton'
import { observer } from 'mobx-react'
import Loading from '../../screens/Loading'
import { IBankAccountModel } from '../../../../models'
import { toJS } from 'mobx'
import { ViewAddedMethods } from '../../screens/Contractor/MoreTab/Wallet/BankCardListing/ViewAddedMethods'
import { AddMethodFAB } from '../../screens/Contractor/MoreTab/Wallet/BankCardListing/AddMethodFAB'

interface ChoosePaymentModalProps {
  visible: boolean
  onClose: (arg?: string) => void
  onPress: (arg: IBankAccountModel) => void
  showModal?: (val: boolean) => void
}

export const ChoosePaymentModal: React.FC<ChoosePaymentModalProps> = ({
  visible,
  onClose,
  onPress,
  showModal,
}) => {
  const { t } = useTranslation('global')
  const [tab, setTab] = useState('Banks')
  const { md } = useResponsive()
  const style = md && { width: 600 }
  return (
    <BuilderBottomModal
      title={t('choose-payment-method')}
      visible={visible}
      onClose={onClose}
      height={620}
    >
      <View style={style}>
        <ViewAddedMethods onPress={onPress} setTab={setTab} />
      </View>
      <AddMethodFAB closePrevious={onClose} tab={tab} showModal={showModal} />
    </BuilderBottomModal>
  )
}

interface ChangePaymentModalProps {
  visible: boolean
  onPress: (arg: IBankAccountModel) => void
  onClose: () => void
}

export const ChangePaymentModal: React.FC<ChangePaymentModalProps> = observer(
  ({ visible, onPress, onClose }) => {
    const { t } = useTranslation('global')
    const store = useStore()
    const {
      screensStore: {
        paymentMethodsStore: {
          paymentMethods,
          getPaymentMethodSubtitle,
          loading,
        },
      },
    } = store

    useEffect(() => {
      store.screensStore.paymentMethodsStore.fetchPaymentMethods()
    }, [store])

    return (
      <BuilderBottomModal
        title={t('change-payment-method')}
        visible={visible}
        onClose={onClose}
        height={600}
      >
        <View style={{ alignItems: 'center', marginTop: 11 }}>
          {loading ? (
            <View style={{ height: 100 }}>
              <Loading />
            </View>
          ) : (
            <>
              {paymentMethods.map((p, i) => {
                return (
                  <ListItem
                    key={i}
                    icon={<CardIconBuilder style={{ height: 40, width: 40 }} />}
                    title={p.name || t('Wallet.credit_debit_card')}
                    subtitle={getPaymentMethodSubtitle(t, p)}
                    otherStyles={{
                      title: { lineHeight: 26 },
                    }}
                    style={{
                      borderColor: '#CCD6DD',
                      borderRadius: 8,
                      marginBottom: 16,
                    }}
                    endIcon={<ArrowBlue style={{ height: 26, width: 26 }} />}
                    onPress={() => onPress(toJS(p))}
                  />
                )
              })}
              <AddNewButton />
            </>
          )}
        </View>
      </BuilderBottomModal>
    )
  },
)
